import _extends from "@babel/runtime/helpers/esm/extends";
import { useCallback } from 'react';
import invariant from 'tiny-invariant';

var calc = function calc(options, crr, pr) {
  var _amountField$currency = _extends({
    amountField: 'amount',
    currencyField: 'currency'
  }, options),
      amountField = _amountField$currency.amountField,
      currencyField = _amountField$currency.currencyField;

  invariant(pr && Array.isArray(pr), 'useMulticurrencyToPrice(...) price is undefined or null and an array is required.');
  invariant(crr && typeof crr === 'string', 'useMulticurrencyToPrice(...) currency is undefined or null and an string is required.');
  return (pr.find(function (p) {
    return p[currencyField] === crr;
  }) || {})[amountField || 'amount'];
};
/**
 *
 */


export default function useMulticurrencyToPrice(options, currency) {
  if (typeof options === 'string') {
    currency = options;
    options = undefined;
  }

  var c1 = useCallback(function (price) {
    return calc(options, currency, price);
  }, [options, currency]);
  var c2 = useCallback(function priceFromMulticurrency(crr, price) {
    return arguments.length === 2 ? calc(options, crr, price) : function (p) {
      return calc(options, crr, p);
    };
  }, [options]);
  return currency ? c1 : c2;
}